import { AgxSpacer, AgxTypography } from '@urbanx/agx.ui-components2';
import Panel from 'components/panel/Panel';
import SupportBackButton from '../SupportBackButton';
import TaskProgressorConfirmationModal from './TaskProgressorConfirmationModal';
import TaskProgressorSelectors from './TaskProgressorSelectors';
import TaskProgressorWorkflow from './TaskProgressorWorkflow';
import useTaskProgressor from './useTaskProgressor';

const TaskProgressor = () => {
  const progressor = useTaskProgressor();

  return (
    <AgxSpacer gap="spacing-xl" fill>
      <AgxSpacer direction="horizontal" gap="spacing-lg" contentAlignment="center" wrap>
        <SupportBackButton />
        <AgxSpacer gap="spacing-xxs">
          <AgxTypography id="task-progressor-title" type="title" size="medium">
            Task Progressor
          </AgxTypography>
          <AgxTypography
            id="task-progressor-subtitle"
            type="caption"
            size="medium"
            color="var(--text-secondary)"
          >
            Staff workflow task progression
          </AgxTypography>
        </AgxSpacer>
      </AgxSpacer>

      <Panel title="Campaign selection">
        <TaskProgressorSelectors
          agencyOptions={progressor.agencyOptions}
          campaignOptions={progressor.campaignOptions}
          selectedAgencyId={progressor.selectedAgencyId}
          selectedCampaignId={progressor.selectedCampaignId}
          isLoadingAgencies={progressor.isLoadingAgencies}
          isLoadingCampaigns={progressor.isLoadingCampaigns}
          isLoadingCampaignDetails={progressor.isLoadingCampaignDetails}
          hasLoadError={progressor.hasLoadError}
          isPending={progressor.isPending}
          onAgencyChange={progressor.onAgencyChange}
          onCampaignChange={progressor.onCampaignChange}
        />
      </Panel>

      {progressor.campaignDetails && (
        <TaskProgressorWorkflow
          campaignDetails={progressor.campaignDetails}
          selectedContract={progressor.selectedContract}
          contractOptions={progressor.contractOptions}
          stageOptions={progressor.stageOptions}
          selectedContractId={progressor.selectedContractId}
          selectedStage={progressor.selectedStage}
          mode={progressor.mode}
          progressContract={progressor.progressContract}
          canProgressContract={progressor.canProgressContract}
          isReinitialiseOnly={progressor.isReinitialiseOnly}
          isPending={progressor.isPending}
          isSaveDisabled={progressor.isSaveDisabled}
          resultingCampaignStageLabel={progressor.resultingCampaignStageLabel}
          resultingContractStageLabel={progressor.resultingContractStageLabel}
          setMode={progressor.setMode}
          setSelectedContractId={progressor.setSelectedContractId}
          setSelectedStage={progressor.setSelectedStage}
          onProgressContractChange={progressor.onProgressContractChange}
          onSave={() => progressor.setShowConfirmation(true)}
        />
      )}

      <TaskProgressorConfirmationModal
        isOpen={progressor.showConfirmation}
        setIsOpen={progressor.setShowConfirmation}
        isPending={progressor.isPending}
        campaignLabel={progressor.selectedCampaignLabel}
        contractLabel={progressor.selectedContractLabel}
        modeLabel={progressor.modeLabel}
        targetStageLabel={progressor.targetStageLabel}
        currentCampaignStageLabel={progressor.currentCampaignStageLabel}
        resultingCampaignStageLabel={progressor.resultingCampaignStageLabel}
        currentContractStageLabel={progressor.currentContractStageLabel}
        resultingContractStageLabel={progressor.resultingContractStageLabel}
        onConfirm={() => void progressor.progressTasks()}
      />
    </AgxSpacer>
  );
};

export default TaskProgressor;
